import { IMeshSectionData } from "@pageBuilder/typings";
import { MeshCascadeRenderer } from "src/mesh/renderers/cascade-renderers/mesh-cascade-renderer";
import { CascadeRendererBase } from "src/shared/cascade-renderer-base";
import { CascadeRendererFactory } from "src/shared/cascade-renderer-factory";
import { MeshSectionRenderer } from "../section/mesh-section-renderer";
import { IRenderingCommonContext } from "@commonRendering/types";

export class MeshSectionCascadeRenderer extends CascadeRendererBase<IMeshSectionData> {

    protected readonly renderer: MeshSectionRenderer;

    public constructor(renderingCommonContext: IRenderingCommonContext) {
        super(renderingCommonContext);
        this.renderer = new MeshSectionRenderer(this.renderingCommonContext);
    }

    public override createByCascade(data: IMeshSectionData): HTMLElement {
        const element = this.renderer.createNew();
        this.renderer.render(element, data);

        const meshRenderer = CascadeRendererFactory.create("Mesh", this.renderingCommonContext) as MeshCascadeRenderer;

        data.slides?.forEach(slide => {
            if (!slide.content.mesh) {
                return;
            }

            const slideContentElement = element.querySelector(`#${slide.id} > .content`) as HTMLElement;
            const meshElement = meshRenderer.createByCascade(slide.content.mesh);

            slideContentElement.append(meshElement);
        });

        return element;
    }

    public override getDataByCascade(element: HTMLElement): IMeshSectionData {
        const data = this.renderer.getData(element) as IMeshSectionData;
        const meshRenderer = CascadeRendererFactory.create("Mesh", this.renderingCommonContext) as MeshCascadeRenderer;

        data.slides?.forEach(slide => {
            const slideElement = (element.querySelector(`#${slide.id}`) ?? element) as HTMLElement; // select element for old sections (before slider)
            const meshElement = slideElement.querySelector(":scope > .content > [data-mesh]") as HTMLElement;

            if (meshElement) {
                slide.content.mesh = meshRenderer.getDataByCascade(meshElement);
            }
        });

        return data;
    }

}
